module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1000.ef505aa4.svg";